import type { Condition, PaginatedApiResponse, Technician } from 'types';
import { baseQuery } from '../baseQuery';

export type TechnicianSearchParams = {
  searchParam: 'byName' | 'byID' | 'byEmail' | 'byAddress' | 'byState' | 'byMobile' | 'byPhone';
  searchValue: string;
  status?: Condition | '';
  page?: number;
  perPage?: number;
};

export const getTechniciansSearch = async ({
  searchParam,
  searchValue,
  status,
  page = 1,
  perPage = 5,
}: TechnicianSearchParams): Promise<PaginatedApiResponse<Technician[]>> => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('per_page', String(perPage));
  params.set(`filter[${searchParam}]`, searchValue);

  if (status) {
    params.set('filter[byActive]', status);
  }

  const data: PaginatedApiResponse<Technician[]> = await baseQuery(`technicians/search?${params.toString()}`);

  return data;
};
